import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { initSentryForClient } from "./lib/sentry.client";

initSentryForClient();

async function prepareClient() {
  const mockFlag = String(import.meta.env.VITE_MOCK_API || "")
    .trim()
    .toLowerCase();
  const enableMocks =
    import.meta.env.DEV &&
    (mockFlag === "1" ||
      mockFlag === "true" ||
      mockFlag === "yes" ||
      mockFlag === "on");

  if (enableMocks) {
    try {
      const { worker } = await import("./mocks/browser");
      await worker.start({ onUnhandledRequest: "bypass" });
    } catch (error) {
      console.warn(
        "MSW failed to start, continuing without client mocks.",
        error,
      );
    }
  }
}

prepareClient().then(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter />
      </StrictMode>,
    );
  });
});
